import { LoadStatus } from '../load-status';

export const SOFTWARE_LICENCES_FEATURE_KEY = 'softwareLicences';

// Re-export so the slice files (actions/reducer/selectors) can keep importing the naked
// value-helper type from the state barrel. The canonical definition lives with the model.

export type SoftwareLicencesEntry = Readonly<{
    data: SoftwareLicenceState[];
    status: LoadStatus;
}>;

export type SoftwareLicencesCollectionState = Readonly<{
    licences: Record<string, SoftwareLicencesEntry>;
}>;

export const initialSoftwareLicencesState: SoftwareLicencesCollectionState = {
    licences: {},
};

export type SoftwareLicenceState = Readonly<{
    materialNumber: string;
    serialNumber: string;
    description: string;
    startDate: string;
    endDate: string;
    status: string;
}>;
